module.exports = __webpack_public_path__ + "img/8EF87609-71BE-4F8F-8C75-AE7C4CEDD815.3afe87c4.jpg";